export var p2EnvPlatform = 'P2.0';
